<template lang="pug">
div(class="home" style="overflow-x:hidden")
  video-bg( :sources="[]" img="/static/img/mycavalor_home_l.jpg" )
    div(class="hero-container")
        div(class="hero flex-center" )
          h1(class="hero-title") {{$t('label.welcome')}}
          div(style="display:flex;justify-content:center;")
            md-button.md-raised.md-primary(@click.stop="go('help')"  style="color:#012c58;margin:8px;") {{$t('button.intro')}}
            md-button.md-raised.md-primary(@click="go('step/data')"  style="color:#012c58;margin:8px") {{$t('button.start')}}
  div(class="not-hero flex-center bg-info" style="background-color:white;overflow:hidden;position: relative;bottom:0")
    .md-layout(style="padding-top:16px")
      .md-layout-item.md-alignment-top-left.md-size-100
          md-content(style="color:#012c58;background:white;padding-left:16px;padding-right:16px;margin-left:auto;margin-right:auto;text-align:justify" v-html="$t('label.intro')")
      .md-layout-item.md-alignment-top-left.md-size-50.md-xsmall-size-50.md-small-size-50
          a(href="https://www.equinerationcalculator.com" target="_blank")
            img.logo2(src="/static/img/frasc-logo.png")
          md-content.info2(style="color:#012c58;background:white;padding-left:16px;padding-right:16px;margin-left:auto;margin-right:auto") 
            | {{ $t('label.intro-frasc') }}
      .md-layout-item.md-alignment-top-left.md-size-50
          img.logo2(src="/static/img/logo_cavalor.png")
          .md-layout
            md-content.info2(style="color:#012c58;background:white;padding-left:16px;padding-right:16px;margin-left:auto;margin-right:auto") 
              | {{ $t('label.intro-consumer') }}
            .md-layout-item.md-alignment-top-left.md-size-100
              h4(style="text-align:center;font-weight:bold;color: rgb(1, 44, 88);") Cavalor Consumer Line
              h5(style="text-align:center;color: rgb(1, 44, 88);") {{$t('label.atyourservice')}}
              h5(style="text-align:center;color: rgb(1, 44, 88);") + 32 (0)9 220 25 25
      .md-layout-item.md-alignment-bottom-right.md-size-100(style="margin-top:3%")
          div(style="padding: 8px;text-align:center;display:block;margin:auto") 
              router-link(:to="`/${language}/privacy-policy`" class="md-accent") Privacy &amp; Cookie Policy | Copyright © 2018 Nutriquine NV  
</template>
<script>
import { mapState } from 'vuex'
import { DISABLE_TOOLBAR } from '@/constants/store'
import VideoBg from 'vue-videobg'
export default {
  name: 'home',
  metaInfo: {
    title: 'MyCavalor',
    // override the parent template and just use the above title only
    titleTemplate: null
  },
  components: {
    VideoBg
  },
  computed: {
    ...mapState([
      'language'
    ])
  },
  methods: {
    go (id) {
      var to = '/' + this.language + '/' + id
      // console.log('Pressed Go route: ', to)
      // this.$router.push({path: to}).catch(() => {})
      this.$router.push({path: to})
    }
  },
  mounted () {
    this.$store.commit(DISABLE_TOOLBAR)
  }
}
</script>
<style scoped>
* {
  margin: 0;
  padding: 0;
}
html {
  overflow: hidden;
}
.hero_container {
  position: relative;
  width: 100%;
  padding-top: 100%;
}
.logo {
  width:auto;
  height:120px;
  display: block;
  margin:auto;
}
.logo2 {
  width:auto;
  height:120px;
  display: block;
  margin:auto;
}
.info2 {
  text-align: justify;
}
.hero {
width: 100%;
height: 100%;
min-width: 100%;
position: absolute;
}
.hero::after {
background-image: url(/static/img/mycavalor_home_l.jpg);
background-repeat: no-repeat;
background-size: 100% auto;
content: "";
display: block;
position: absolute;
top: 0;
left: 0;
z-index: 0;
width: 100%;
height: 100%;
max-height: 100vh;
overflow:hidden;
}
@media only screen and (min-width: 320px) and (max-width: 459px) {
.hero::after {
background-image: url(/static/img/mycavalor_home.jpeg);  
}
.hero {
  height: 100%;
}
.hero-title {
  padding: 0 10%;
}
.logo,
.logo2 {
  height:60px;
}
.info2 {
  font-size: 10px;
}
.VideoBg {
  height: calc(100vw * 1.29) !important;
}
}

@media only screen and (min-width: 460px) and  (max-width: 719px) {
.hero::after {
background-image: url(/static/img/mycavalor_home_l.jpg);
}
.info2 {
  font-size: 12px;
}
.VideoBg {
  height: calc(100vw * 0.48) !important;
}
}

@media only screen and (min-width: 720px) and (max-width: 979px) {
.hero::after {
background-image: url(/static/img/mycavalor_home_l.jpg);

}
.hero-title {
  top: 20px;
}
.logo,
.logo2 {
  height:90px;
}
.VideoBg {
  height: calc(100vw * 0.48) !important;
}
}

@media only screen and (min-width: 980px) and (max-width: 1239px) {
.hero::after {
background-image: url(/static/img/mycavalor_home_l.jpg);

}
.VideoBg {
  height: calc(100vw * 0.48) !important;
}
}

@media only screen and (min-width: 1240px) and (max-width: 1499px) {
.hero::after {
background-image: url(/static/img/mycavalor_home_l.jpg);

}
.VideoBg {
  height: calc(100vw * 0.48) !important;
}
}

@media only screen and (min-width: 1500px) and (max-width:1759px) {
.hero::after {
background-image: url(/static/img/mycavalor_home_l.jpg);

}
h1 {
    font-size: 2rem;
}
.md-button {
  font-size: 16px;
}
.VideoBg {
  height: calc(100vw * 0.48) !important;
}
}

@media (min-width: 1760px) {
.hero::after {
background-image: url(/static/img/mycavalor_home_l.jpg);

}
.hero-title {
  font-size: 2 rem;
}
.VideoBg {
  height: calc(100vw * 0.48) !important;
}
}
.flex-center {
display: flex;
flex-direction: column;
justify-content: center;
align-content: center;
}
.hero-message {
color: #000;
text-shadow: #343a40 2px 2px;
min-width: 100%;
min-height: 12em;
position: relative;
}
.hero-message::before {
content: "";
display: block;
position: absolute;
margin-left: 0;
min-width: 100%;
min-height: 12em;
z-index: -1;
background-color: #343a40;
}
@media(min-width:1024px) {
.hero-message {
min-width: 50%;
min-height: 12em;
}
.hero-message::before {
margin-left: 25%;
min-width: 50%;
min-height: 12em;
}
}
.hero-title {
width: 100%;
display: block;
text-align: center;
color:#feda23;
position: relative;
}

.hero-title {
margin: 3% 0;
  /* text-transform: uppercase; */
}
.hero::after {
background-color: #343a40;
content: "";
display: block;
position: absolute;
top: 0px;
left: 0px;
width: 100%;
height: 100%;
z-index: -1;
}
</style>


// WEBPACK FOOTER //
// src/pages/Home.vue